import { combineReducers } from 'redux';

import player from './player/state/reducer';
import videoSource from './player/videoSource/reducer';
import cdnToken from './player/cdnToken/reducer';
import auditude from './ads/auditude/reducer';

export default combineReducers({
    player,
    videoSource,
    cdnToken,
    auditude
});



// WEBPACK FOOTER //
// ./src/reducers.js